import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //用来设定导航条是否展开
    menuIsCollapse: false,
    loadingState:true,
  },
  getters: {
    //获取导航条状态
    getMenuIsCollapse: state => {
      return state.menuIsCollapse
    },
    //获取当前显示状态
    getLoadingState: state => {
      return state.loadingState
    },
  },
  mutations: {
    //修改导航条状态
    setMenuIsCollapse: (state, menuState) => {
      state.menuIsCollapse = menuState;
    },
    //修改是否展示loading
    setLoadingState: (state, laoding) => {
      state.loadingState = laoding;
    },
  },
  actions: {
  },
  modules: {
  }
})
